exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome.page-container {\n  font-family: \"Monda\", sans-serif; }\n  .welcome.page-container .headers {\n    padding: 1rem 3%; }\n  .welcome.page-container .page {\n    padding: 3% 8%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/layouts/welcome/welcome.scss
// module id = 181
// module chunks = 16